import { IndustriesQuery, IndustriesQueryVariables, OccupationIndustry } from "@ctypes";
import { INDUSTRIES } from "@graphql";
import { useQuery } from "@hooks/apollo";

export const useIndustries = () => {
  const { data: queryData, ...rest } = useQuery<IndustriesQuery, IndustriesQueryVariables>(
    INDUSTRIES,
  );

  const keys = (() => {
    if (!queryData?.industries) return [];

    return Object.keys(queryData.industries);
  })() as Array<OccupationIndustry>;

  const values = (() => {
    if (!queryData?.industries) return [];

    return Object.values(queryData.industries);
  })() as Array<string>;

  return { keys, values, isEmpty: !queryData?.industries, ...rest };
};
